export default "__VITE_ASSET__Ci6_49e6__"